export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="lg:w-[42%] flex-shrink-0">
            <div className="relative w-full aspect-[4/5] max-w-[420px] mx-auto rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20woman%20hands%20gently%20browsing%20fashion%20products%20on%20a%20clean%20modern%20tablet%20with%20warm%20cream%20background%2C%20soft%20natural%20daylight%20from%20window%2C%20cozy%20trustworthy%20atmosphere%2C%20neutral%20beige%20and%20sand%20tones%2C%20editorial%20lifestyle%20photography%20with%20gentle%20shadows%2C%20sophisticated%20minimalist%20aesthetic%2C%20warm%20inviting%20mood%2C%20no%20text%20or%20logos%20visible&width=800&height=1000&seq=trust-browsing-scene-v3-2026&orientation=portrait"
                alt="itaobuyspreadsheet safe and trusted shopping platform"
                title="Is itaobuyspreadsheet safe? Trust and safety information"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[58%]">
            <span className="inline-block text-xs font-label text-foreground-600 tracking-wider uppercase whitespace-nowrap">
              Trusted by 10,000+ Shoppers
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.1]">
              Is <span className="italic">itaobuyspreadsheet</span><br />
              Safe to Use?
            </h2>
            <div className="mt-8 space-y-6">
              <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed font-label italic border-l-4 border-accent-400 pl-6">
                "The itaobuyspreadsheet system is designed for informational browsing and structured product comparison only. All data served through our platform is for reference and research purposes, helping shoppers make informed decisions before proceeding to verified product sources."
              </blockquote>
              <p className="text-sm text-foreground-600 leading-relaxed font-label">
                Our platform operates as a structured data aggregator. We do not handle transactions, store payment information, or collect personal shopping data. Every external link redirects you to the official product source with clear attribution. The itaobuy sheet database is regularly audited to ensure link integrity and data accuracy, providing a trustworthy bridge between research and purchase.
              </p>
              <div className="flex flex-wrap items-center gap-6 pt-2">
                <div className="flex items-center space-x-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600">
                    <i className="ri-shield-check-line"></i>
                  </span>
                  <span className="text-sm font-label text-foreground-700">Verified Sources</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600">
                    <i className="ri-lock-line"></i>
                  </span>
                  <span className="text-sm font-label text-foreground-700">No Data Collection</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600">
                    <i className="ri-refresh-line"></i>
                  </span>
                  <span className="text-sm font-label text-foreground-700">Daily Audits</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}